// Centralized dayjs plugin setup. This file is imported once from gatsby-browser.js and
// gatsby-ssr.jsx so every other module can `import dayjs from 'dayjs'` and rely on the
// extensions being available globally.
//
// Note: dayjs.extend is idempotent, so multiple imports of this module are safe.
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(customParseFormat);

export default dayjs;
